<div class="container">
  <app-advice-card [title]="'TGA.Advice.General.RiskAnalysis.Title' | translate">
    <app-risk-legend></app-risk-legend>
    <div class="advices-container">
      @for (adviceLine of enhancedAdviceLines(); track adviceLine) {
        <app-advice-card [title]="adviceLine.issueType | translate" [infoTooltipText]="adviceLine.tooltipText">
          <div class="advice-text">
            @if (adviceLine.enhancedMeasures; as measures) {
              @if (measures.length > 0) {
                <div>
                  <div class="subtitle">{{ 'TGA.Advice.General.RiskAnalysis.Subtitle' | translate }}</div>
                  @for (measure of measures; track measure.translationCode) {
                    @if (measure.isSummation) {
                      <ul class="ul-item">
                        <li>
                          <span [innerHTML]="measure.translatedText"></span>
                        </li>
                      </ul>
                    } @else {
                      <div>
                        <span [innerHTML]="measure.translatedText"></span>
                      </div>
                    }
                  }
                  @if (adviceLine.soilVarietyDifferences) {
                    <div class="soil-variety-differences">
                      <div class="soil-variety-differences-title">
                        {{ 'TGA.Advice.General.RiskAnalysis.ManualInput.Title' | translate }}
                      </div>
                      <div class="manual-input">{{ adviceLine.soilVarietyDifferences }}</div>
                    </div>
                  }
                </div>
              }
            }
          </div>
          <div class="actions">
            <div class="action-item">
              <span class="action-label">{{ 'TGA.Advice.General.RiskAnalysis.RiskOfDamage' | translate }}</span>
              <div
                class="action-bar-wrap"
                aria-hidden="true"
                [attr.title]="'TGA.Advice.General.RiskAnalysis.Legend.' + adviceLine.riskOfDamage | translate"
              >
                <div [ngClass]="['action-bar', riskClass(adviceLine.riskOfDamage)]"></div>
              </div>
            </div>

            <div class="action-item">
              <span class="action-label">{{ 'TGA.Advice.General.RiskAnalysis.NecessityForAction' | translate }}</span>
              <div
                class="action-bar-wrap"
                aria-hidden="true"
                [attr.title]="'TGA.Advice.General.RiskAnalysis.Legend.' + adviceLine.necessityForAction | translate"
              >
                <div [ngClass]="['action-bar', actionClass(adviceLine.necessityForAction)]"></div>
              </div>
            </div>
          </div>
        </app-advice-card>
      }
    </div>
  </app-advice-card>
  @if (cropVarietyName()) {
    <app-variety-properties-risk-dashboard-widget
      [cropVarietyName]="cropVarietyName()!"
    ></app-variety-properties-risk-dashboard-widget>
  }
</div>
